<template>
  <div class="tender-activity-box">
    <!-- 操作栏 -->
    <div class="action-bar">
      <el-input
        placeholder="请输入用户Id"
        v-model.number="params.userId"
        clearable
        size="small"
        @change="buyPage()"
        class="param-input"
      ></el-input>
      <el-input
        placeholder="请输入用户昵称"
        v-model="params.userName"
        clearable
        size="small"
        @change="buyPage('status')"
        class="param-input"
      ></el-input>
      <el-input
        placeholder="请输入模特id"
        v-model.number="params.modelId"
        clearable
        size="small"
        @change="buyPage('status')"
        class="param-input"
      ></el-input>
      <el-date-picker
        v-model="time"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        @change="changeTime"
      ></el-date-picker>
      <el-button type="primary" size="small" @click="buyPage('status')">搜索</el-button>
            <el-button type="primary" size="small" @click="Action('add')">+新增</el-button>
      <div>
        <span>活动参与人数：</span>
        <el-input v-model="this.joinPersons" disabled size="small" class="param-input"></el-input>
        <el-button type="primary" size="small" @click="join(joinPersons)">编辑参与人数</el-button>
      </div>
    </div>
    <!-- 表格数据 -->
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column
        prop="userId"
        label="用户id"
        align="center"
        min-width="120"
        fixed
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{scope.row.userId || '未知'}}</span>
        </template>
      </el-table-column>

      <el-table-column prop="userLogo" label="图片" align="center" min-width="100">
        <template slot-scope="scope">
          <img-load :src="imgUrl + scope.row.userLogo" :width="'90px'" :height="'120px'" />
        </template>
      </el-table-column>
      <el-table-column
        prop="userName"
        min-width="160"
        label="用户昵称"
        align="center"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{scope.row.userName ||'未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="modelId" label="模特id" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{scope.row.modelId}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="date" label="期号"  align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{scope.row.date }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="quantity" label="购买份数" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{scope.row.quantity }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="serials" label="购买号码" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{scope.row.serials }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="soldOut" label="是否买断" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{scope.row.soldOut | soldOutType }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{scope.row.updatedAt | changeDate}}</span>
        </template>
      </el-table-column>
            <el-table-column prop="operating" label="操作" align="center" fixed="right" width="150">
        <template slot-scope="scope">
          <el-button type="success" size="mini" icon="el-icon-edit" @click="Action('edit',scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[5,10,15,20]"
      :current-page="params.page"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      @size-change="changeSize"
      :total="total"
      v-if="total > 10"
      @current-change="changeCurrent"
    ></el-pagination>
    <join-num ref="joinNum" @handlerCodeList="handlerCodeList"></join-num>
    <!--新增、编辑tag弹窗-->
    <code-action ref="codeAction" @handlerCodeList="handlerCodeList"></code-action>

  </div>
</template>
<script>
import API from "@/api";
import baseConfig from "@/utils/serverUrlConfig";
import { changeTime } from "@/utils/global";
import JoinNum from "./components/joinNum";
import CodeAction from './components/codeAction'
export default {
  data() {
    return {
      tableData: [],
      joinPersons: "",
      loading: false,
      total: "",
      time: "",
      imgUrl: baseConfig.imgUrl,
      params: {
        page: 1,
        pageSize: 10
      }
    };
  },
  created() {
    this.buyPage();
  },
  components: {
    JoinNum,
        CodeAction,
  },
  methods: {
    // 请求获奖记录列表
    buyPage(type) {
      if (type === "status") {
        this.params.page = 1;
      }
      this.loading = true;
      API.buyPage(this.params)
        .then(res => {
          if (res.code === 200 && res.data.data) {
            this.tableData = res.data.data;
            this.total = res.data.total;
            this.joinPersons = res.data.joinPersons;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.loading = false;
        });
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size;
      this.params.page = 1;
      this.buyPage();
    },
    // 当前页发生变化触发
    changeCurrent(page) {
      this.params.page = page;
      this.buyPage();
    },
    // 时间触发回调
    changeTime(time) {
      if (time) {
        this.params.start = changeTime(time[0]) || "";
        this.params.end = changeTime(time[1]) || "";
      } else {
        this.params.start = "";
        this.params.end = "";
      }
      this.buyPage("status");
    },

    // 编辑活动成功回掉
    handlerCodeList() {
      this.buyPage();
    },
        // 新增、 修改tags
    Action(type, data) {
      this.$refs.codeAction.open(type, data);
    },
    // 编辑参与人数
    join(joinPersons) {
      this.$refs.joinNum.open(joinPersons);
    }
  }
};
</script>
<style scoped>
</style>
